/*!*
 * @author mi
 * @date 2019/4/26
 * @project xingzhiyuan_2019
 * @desc 本地存储操作，
 *       代替native localStorage api
 */
import _ from 'lodash'

export function setLocalItem (key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}

export function getLocalItem (key) {
  let value = localStorage.getItem(key)
  try {
    return JSON.parse(value)
  } catch (e) {
    if (value === 'undefined') return null
    return localStorage.getItem(key)
  }
}

export function removeLocalItem (key) {
  _.each(arguments, item => {
    localStorage.removeItem(item)
  })
}
